import React from 'react';
import { observer } from 'mobx-react';
import { Styles } from './styles';

export const NavigationIcon = observer(({ children, ...rest }) => <Styles {...rest}>{children}</Styles>);
